<template>
    <div style="display:inline-block">
        <svg :width="width" :height="height" viewBox="0 0 14 12" xmlns="http://www.w3.org/2000/svg" style="vertical-align: top;">
            <path d="M10.1818 0C8.84545 0 7.66818 0.7 7 1.8C6.33182 0.7 5.15455 0 3.81818 0C1.71818 0 0 1.8 0 4C0 7.96667 7 12 7 12C7 12 14 8 14 4C14 1.8 12.2818 0 10.1818 0Z" :fill="fill" ></path>
        </svg>
    </div>
</template>

<script>
    export default {
        name: "IconHeart",
        props : {
            width : {
                type : String,
                default : null,
            },
            height : {
                type : String,
                default : null,
            },
            fill : {
                type : String,
                default : 'white',
            }
        }

    }
</script>

<style scoped>

</style>